import React from 'react';
import {connect} from 'react-redux';
import {PropTypes} from 'prop-types';
import {fetchFromHub} from "../../actions/networkActions";
import {getTranslation} from '../../translations/translationUtils';
import OverviewImageButtonPanel from '../../components/OverviewImageButtonPanel';
import OverviewImageButton from "../../components/OverviewImageButton.js";
import FullScreenLoader from '../../components/FullScreenLoader.js';

class SpaOverview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            loaded: false,
        }
    }

    componentDidMount() {
        this.props.fetchFromHub(`spacategory`, this.update);
    }

    update = (categories) => {
        this.setState({
            items: categories,
            loaded: true,
        });
    };


    render() {
        if (!this.state.loaded) {
            return <FullScreenLoader />
        }

        if (this.state.items.length === 0) {
            return ( <div>{this.context.t("no_spa_available")}</div>);
        }

        return (
            <div>
                <OverviewImageButtonPanel>
                    {this.state.items.map((item) => {
                        const title = getTranslation(item.title);
                        const thumbnailUrl = `${this.props.configuration.hubUrl}blobs/image?reference=${item.id}&width=400`;
                        const itemUrl = `/spa/category/${item.id}` ;

                        return (
                            <OverviewImageButton
                                heightWidthRatio="100%"
                                truncateTitle={true}
                                key={item.id}
                                link={itemUrl}
                                title={title}
                                thumbnail={thumbnailUrl}
                            />);
                    })}
                </OverviewImageButtonPanel>
            </div>
        );
    }
}

SpaOverview.contextTypes = {
    t: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    // lang used to trigger rerender in new language when changed
    return {
        configuration: state.configuration,
        lang: state.i18nState.lang
    };
};


export default connect(mapStateToProps, {fetchFromHub: fetchFromHub})(SpaOverview);